import { Holiday } from '@/src/constants/holidayCalendarConfig'
import dayjs from 'dayjs'

/**
 * Filters holidays based on visibility rules:
 * 1. Single day holiday (from === to): Show if from >= today
 * 2. Range holiday: Show if to >= today (even if from < today)
 * 3. Don't show if to < today
 * @param holidays - Array of holidays to filter
 * @param currentDate - Current date (defaults to today)
 * @returns Filtered array of visible holidays
 */
export const filterVisibleHolidays = (
    holidays: Holiday[],
    currentDate: Date = new Date()
): Holiday[] => {
    const today = dayjs(currentDate).startOf('day')

    return holidays.filter((holiday) => {
        const fromDate = dayjs(holiday.dateRange.from).startOf('day')
        const toDate = dayjs(holiday.dateRange.to).startOf('day')

        // Rule 3: Don't show if to date has passed
        if (toDate.isBefore(today)) {
            return false
        }

        // Rule 1 & 2: Single day holiday - show if from >= today
        if (fromDate.isSame(toDate)) {
            return fromDate.isSame(today) || fromDate.isAfter(today)
        }

        // Rule 3: Range holiday - show if to >= today (even if from < today)
        return toDate.isSame(today) || toDate.isAfter(today)
    })
}

